import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/rechargeGift/totalCoin3.png'
import _imports_1 from '@/assets/rechargeGift/coin.png'


const _hoisted_1 = { class: "detailsContainer" }
const _hoisted_2 = { class: "customText" }
const _hoisted_3 = { class: "cashBackTotal" }
const _hoisted_4 = { class: "cashBackTotalAmount" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }

import { PropType, ref, } from 'vue';
import { formatCurrency } from '@/utils/commonFunction';
import { getBetList, getDayList } from '@/view/components/supportFunction';
import CashbackWeekDayCard from './cashbackWeekDayCard.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'cashbackWeekDetails',
  props: {
    cashbackTotal: {
        type: Number,
        default: () => 0
    },
    betList: {
        type: Array as PropType<any[]>,
        default: () => []
    },
    istodayClaimed: {
        type: Boolean,
        default: () => false
    },
    type: {
        type: String,
        default: () => ''
    },
    title: String,
    todayDayRewards: {
        type: Object as PropType<any>
    },
    isShowTodayCard: {
        type: Boolean,
        default: () => false
    },
},
  setup(__props) {

const props = __props
const showDetails = ref(false)
const handleDetailsShow = () => {
    showDetails.value = !showDetails.value
}
const setdayList = (data: any) => getDayList(props.type, data)
const setBetList = () => getBetList(props.betList, props.isShowTodayCard)

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "19" }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "detailsText" }, "RECOMPENSA DE RECARGA", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "5" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              onClick: handleDetailsShow,
              class: "detailIcon detailsTag"
            }, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('activity.details')), 1),
              _createVNode(_component_van_icon, { name: "arrow" })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_van_row, { class: "total_card" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "24",
          style: {"display":"flex","align-items":"center","justify-content":"center"}
        }, {
          default: _withCtx(() => [
            _cache[1] || (_cache[1] = _createElementVNode("img", {
              src: _imports_0,
              alt: "",
              width: "18%",
              class: "glow-image"
            }, null, -1)),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('activity.cashBackTotal')), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(formatCurrency)(__props.cashbackTotal)), 1),
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              src: _imports_1,
              alt: "",
              width: "5%"
            }, null, -1))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (showDetails.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (__props.isShowTodayCard)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(CashbackWeekDayCard, {
                  createTime: __props.todayDayRewards.date,
                  "total-amount": __props.todayDayRewards.totalAmount,
                  istodayClaimed: __props.istodayClaimed,
                  title: __props.title,
                  "day-list": __props.todayDayRewards.rewards
                }, null, 8, ["createTime", "total-amount", "istodayClaimed", "title", "day-list"])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(setBetList(), (item, index) => {
            return (_openBlock(), _createBlock(CashbackWeekDayCard, {
              key: index,
              createTime: item.lossDate ?? item.createTime,
              title: __props.title,
              "day-count": item.dayCount ?? item.day,
              "activity-status": item.status,
              "total-amount": item.totalBetAmount ?? item.rechargeTotal ?? item.totalBetLoss,
              istodayClaimed: __props.istodayClaimed,
              "available-amount": item.remainGiftAmount ?? item.availableAmount,
              "day-list": setdayList(item.dayRewards)
            }, null, 8, ["createTime", "title", "day-count", "activity-status", "total-amount", "istodayClaimed", "available-amount", "day-list"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})